import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { CARDS, ROOM_META } from './cards.jsx';
import RoomContent from './RoomContent.jsx';
import CombatHud from './CombatHud.jsx';
import roomScene from '../assets/scenes/room.svg';
import './rooms.css';

const Room = () => {
  const { id } = useParams();
  const card = CARDS.find((c) => c.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!card) return <Navigate to="/" replace />;
  const room = ROOM_META[card.room];

  return (
    <div className={`roomView room-${card.room} type-${card.type} rarity-${card.rarity}`}>
      <div className="roomBackdrop" aria-hidden="true">
        <img className="roomScene" src={roomScene} alt="" />
      </div>

      <header className="roomBar">
        <Link to="/" className="retreat">
          ◂ Retreat
        </Link>
        <span className="roomTag">
          <span className="roomTagType">{room?.label}</span>
          <span className="roomTagName">{card.name}</span>
        </span>
        <span className="roomEnergy">{card.cost}</span>
      </header>

      <CombatHud card={card} />

      <main className="roomBody">
        <RoomContent id={id} />
      </main>
    </div>
  );
};

export default Room;
